module.exports = __webpack_public_path__ + "static/media/form-screen3.36e1dadf.jpg";